<template>
    <b-modal id="createModal" ref="modal" title="Create a Chemical Active Ingredient" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Chemical Active Ingredient Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <div class="form-group">
            <label>Restricted Entry Interval (days)</label>
            <div class="position-relative">
                <VueMask v-model.number="contamination_period" class="form-control"
                         :class="{'is-invalid': errors.has('contamination_period')}"
                         placeholder="0..."
                         :options="{numeral: true, numeralThousandsGroupStyle: 'thousand'}" />
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import filterChemicalActiveIngredientQuery from '@views/ChemicalActiveIngredients/Browse/queryListChemicalActiveIngredients.graphql';
import createChemicalActiveIngredientMutation from '@views/ChemicalActiveIngredients/CreateModal/mutationCreateChemicalActiveIngredient.graphql';

export default {
  name: 'create-modal',
  apollo: {},
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      contamination_period: null,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: createChemicalActiveIngredientMutation,
            variables: {
              input: { name: this.name, contamination_period: this.contamination_period },
            },
            refetchQueries: [
              { query: filterChemicalActiveIngredientQuery },
              { query: filterChemicalActiveIngredientQuery, variables: { input: { include_deleted: true } } },
            ],
          })
          .then(() => {
            this.$notifySuccess('Chemical Active Ingredient created!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure('Unfortunately, we were unable to do that!');
          });
      });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
